/* tslint:disable */
/* eslint-disable */
export enum TargetType {
  Anecdotal = 1,
  DiscreteTrialTeaching = 2,
  ConditionalDiscrimination = 3,
  Duration = 4,
  Echoic = 5,
  FluencyRate = 6,
  Frequency = 7,
  GroupedFrequency = 8,
  JumpTo = 9,
  Quantity = 10,
  TaskAnalysis = 11,
  Toileting = 12,
  WholePartialInterval = 13,
  Currency = 14,
  Intensity = 15,
  Rate = 16
}
